var _rect, _rect2, _path, _rect3, _path2, _path3, _rect4, _path4, _path5, _path6, _path7, _path8, _path9, _rect5, _g, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 160,
    viewBox: "0 0 180 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 160,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6852,
    y: 58.2644,
    width: 46.2794,
    height: 85.1712,
    rx: 5.96995,
    transform: "rotate(-43.488 31.6852 58.2644)",
    fill: "white",
    stroke: "#343239",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9772 49.8981L57.1345 40.2632C57.3987 40.0126 57.816 40.0237 58.0665 40.2878C58.3171 40.552 58.3061 40.9693 58.0419 41.2199L47.8847 50.8547C47.6205 51.1053 47.2032 51.0943 46.9526 50.8301C46.702 50.5659 46.7131 50.1486 46.9772 49.8981Z",
    fill: "#343239",
    stroke: "#343239",
    strokeWidth: 2.68142
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.8903,
    y: 75.4918,
    width: 66.0512,
    height: 42.8849,
    rx: 6.74325,
    transform: "rotate(-43.5309 74.8903 75.4918)",
    fill: "#F2F0EB",
    stroke: "#343239",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.821 91.1382L117.287 75.496",
    stroke: "#343239",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.176 94.6685L115.153 84.2403",
    stroke: "#343239",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96.66,
    y: 88.2121,
    width: 11.3516,
    height: 14.0235,
    rx: 2.39161,
    transform: "rotate(-133.531 96.66 88.2121)",
    fill: "#A69D79",
    stroke: "#343239",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7015 76.7735L100.062 84.522",
    stroke: "#343239",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.508 81.2778L97.9072 76.435L100.813 73.6746",
    stroke: "#343239",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.508 81.2778L100.668 79.3407L103.573 76.5803",
    stroke: "#343239",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8574 84.8618L97.7631 82.1014",
    stroke: "#343239",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0957 81.9556L95.0014 79.1952",
    stroke: "#343239",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3327 47.6158L54 55.5L61.8842 63.8327L70.2168 55.9485L62.3327 47.6158ZM63.5556 58.7505C63.6136 58.8119 63.7144 58.8108 63.7786 58.7501L65.0391 57.5574C65.1033 57.4967 65.1082 57.3978 65.0501 57.3365L60.6613 52.6979C60.6032 52.6366 60.5042 52.636 60.44 52.6967L59.1795 53.8894C59.1153 53.9501 59.1087 54.0507 59.1667 54.112L63.5556 58.7505ZM62.177 58.7652L62.4982 58.4613L60.4877 56.3365C60.4297 56.2751 60.3308 56.2744 60.2666 56.3351L59.537 57.0254L59.2291 57.3168C59.165 57.3775 59.1601 57.4764 59.2181 57.5377L60.3555 58.7398C60.5836 58.9809 60.8996 59.1206 61.236 59.1292C61.5825 59.1379 61.9217 59.0067 62.177 58.7652ZM64.3656 55.1415L64.0445 55.4453L62.034 53.3205C61.9759 53.2592 61.9807 53.1604 62.0448 53.0997L62.7762 52.4077L63.0824 52.118C63.1465 52.0573 63.2455 52.0579 63.3036 52.1193L64.441 53.3213C64.6691 53.5624 64.7911 53.8857 64.7811 54.222C64.7707 54.5684 64.6209 54.8999 64.3656 55.1415Z",
    fill: "#343239"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4530_337191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 131,
    width: 73,
    height: 15
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.9998,
    y: 131.971,
    width: 72,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4530_337191)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 91.9678,
    cy: 113.881,
    r: 30.9681,
    fill: "#F2F0EB"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9998 131.471H128",
    stroke: "#343239",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.0685d3c926a2bfa7e67ea23b49b4b856.svg";
export { ForwardRef as ReactComponent };